import ManageBulkMessage from '@/PageComponents/Message/ManageBulkMessage';
import Breadcrumbs from '@/components/breadcrumbs';
import { FC } from 'react';
import * as Enums from '@/utils/enums';
import { createFileRoute } from '@tanstack/react-router'



const CreateBulkMessage: FC<{}> = ({ }: any) => {

    return (<>

        <div className="manage-container">

            <div className="title">
                <Breadcrumbs currPage={{ text: 'Create Bulk SMS', link: '/message/bulk/create', type: 'create' }} />
            </div>

            <ManageBulkMessage inModal={false} messageType={Enums.MessageType.SMS}/>

        </div>

        <style jsx>{`
            
        `}</style>
    </>);
};

export default CreateBulkMessage;

export const Route = createFileRoute('/_authenticated/message/bulk/create')({ component: CreateBulkMessage })
